import { useState } from 'react';
import { companyInfo } from '../data';

export default function Map() {
  const [showTooltip, setShowTooltip] = useState(true);

  const googleMapsUrl = `https://maps.app.goo.gl/J8aj4NhgwQqboc9CA`;

  return (
    <div className="relative w-full h-[400px] bg-navy-950 overflow-hidden border border-slate-100 group">
      {/* Minimalist Stylized Map Background (SVG) */}
      <svg 
        className="absolute inset-0 w-full h-full opacity-40 select-none" 
        viewBox="0 0 800 400" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Grid lines / Coordinates */}
        <line x1="100" y1="0" x2="100" y2="400" stroke="#1e293b" strokeWidth="1" strokeDasharray="4 4" />
        <line x1="300" y1="0" x2="300" y2="400" stroke="#1e293b" strokeWidth="1" strokeDasharray="4 4" />
        <line x1="500" y1="0" x2="500" y2="400" stroke="#1e293b" strokeWidth="1" strokeDasharray="4 4" />
        <line x1="700" y1="0" x2="700" y2="400" stroke="#1e293b" strokeWidth="1" strokeDasharray="4 4" />
        
        <line x1="0" y1="100" x2="800" y2="100" stroke="#1e293b" strokeWidth="1" strokeDasharray="4 4" />
        <line x1="0" y1="200" x2="800" y2="200" stroke="#1e293b" strokeWidth="1" strokeDasharray="4 4" />
        <line x1="0" y1="300" x2="800" y2="300" stroke="#1e293b" strokeWidth="1" strokeDasharray="4 4" />

        {/* Stylized Roads (Aalborg Øst) */}
        {/* Alfred Nobels Vej */}
        <path d="M 0,150 L 800,150" stroke="#334155" strokeWidth="12" strokeLinecap="round" />
        <path d="M 0,150 L 800,150" stroke="#1e293b" strokeWidth="2" strokeDasharray="6 6" />
        
        {/* Niels Jernes Vej */}
        <path d="M 400,0 L 400,400" stroke="#334155" strokeWidth="10" strokeLinecap="round" />
        <path d="M 400,0 L 400,400" stroke="#1e293b" strokeWidth="2" strokeDasharray="6 6" />
        
        {/* Bertil Ohlins Vej */}
        <path d="M 200,50 L 600,350" stroke="#334155" strokeWidth="8" strokeLinecap="round" />

        {/* Universitetsboulevarden (Main highway style) */}
        <path d="M 0,320 C 300,320 500,380 800,380" stroke="#475569" strokeWidth="16" strokeLinecap="round" />

        {/* Surrounding Buildings (Stylized blocks) */}
        <rect x="420" y="80" width="80" height="40" rx="2" fill="#1e293b" opacity="0.6" />
        <rect x="420" y="180" width="100" height="50" rx="2" fill="#1e293b" opacity="0.6" />
        <rect x="280" y="60" width="90" height="45" rx="2" fill="#1e293b" opacity="0.6" />
        <rect x="260" y="220" width="110" height="60" rx="2" fill="#1e293b" opacity="0.6" />
      </svg>

      {/* Map Overlay Info */}
      <div className="absolute top-6 left-6 bg-navy-900/90 backdrop-blur-md border border-navy-800 p-4 text-white max-w-xs z-10 shadow-lg">
        <h4 className="font-display text-sm font-bold text-gold-500 mb-1">Aalborg Kontor</h4>
        <p className="text-xs text-slate-300 leading-relaxed">
          Niels Jernes Vej 10<br />
          9220 Aalborg Ø<br />
          Danmark
        </p>
      </div>

      {/* Interactive Map Pin / Marker */}
      <div 
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex flex-col items-center cursor-pointer z-20"
        onClick={() => setShowTooltip(!showTooltip)}
      >
        {/* Tooltip */}
        <div className={`absolute bottom-full mb-3 bg-white text-navy-950 px-4 py-2 shadow-xl border border-slate-100 whitespace-nowrap transition-all duration-300 flex flex-col items-center ${
          showTooltip ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-2 pointer-events-none'
        }`}>
          <span className="text-xs font-bold font-display">KnowHow GROUP</span>
          <span className="text-[10px] text-slate-500">Niels Jernes Vej 10</span>
          {/* Tooltip Arrow */}
          <div className="absolute top-full left-1/2 -translate-x-1/2 border-8 border-transparent border-t-white" />
        </div>

        {/* Glowing Pin */}
        <div className="relative flex items-center justify-center">
          <div className="absolute w-8 h-8 bg-gold-500/30 rounded-full animate-ping" />
          <div className="absolute w-12 h-12 bg-gold-500/10 rounded-full animate-pulse" />
          <div className="relative w-5 h-5 bg-gold-500 rounded-full border-2 border-white flex items-center justify-center shadow-md">
            <div className="w-1.5 h-1.5 bg-navy-950 rounded-full" />
          </div>
        </div>
      </div>

      {/* Open in Google Maps Button */}
      <a 
        href={googleMapsUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="absolute bottom-6 right-6 px-5 py-2.5 bg-white text-navy-950 text-xs font-bold uppercase tracking-wider shadow-lg hover:bg-gold-500 hover:text-white transition-all duration-300 flex items-center gap-2 focus:outline-none focus:ring-2 focus:ring-gold-400"
      >
        <i className="fa-light fa-map-location-dot" />
        Åbn i Google Maps
      </a>
    </div>
  );
}
